import { IPlainAction } from "../../IPlainAction";

export interface IWorkflow {
  id: string;
  status: "SUCCESSFUL" | "RUNNING";
  siteId: string;
  customerId: string;
  creationTimeUtc: string;
  updateTimeUtc: string;
  workflowInstanceDescription: string;
  workflowType: string;
  steps: IWorkflowStep[];
  createdBy: string;
  csStatus?: string;
}

export interface IWorkflowStep {
  id: number;
  status: "SUCCESSFUL" | "RUNNING" | "WAITING";
  title: string;
  descriptionMd: string;
  actions: IWorkflowAction[];
  isInputStep?: boolean;
  error?: string;
  pending?: boolean;
  shouldSwitchAutomatically?: boolean;
}

export interface IWorkflowAction {
  id: string;
  type: string;
  value: any;
  label: string;
  defaultValue: any;
  regexp?: string; // for TEXT action
  options?: string[]; // list of items for SELECT actions
  defaultToday?: boolean; // use current browser date as defaultValue for DATE action
}

const CURRENT_WORKFLOW_PERSISTED = "CURRENT_WORKFLOW_PERSISTED";
export const persistCurrentWorkflow = (
  workflow: IWorkflow,
): IPlainAction<IWorkflow> => ({
  type: CURRENT_WORKFLOW_PERSISTED,
  payload: workflow,
});

export type ICurrentWorkflowState = IWorkflow | null;

export default function currentWorkflowReducer(
  state: ICurrentWorkflowState = null,
  action: IPlainAction<any>,
): ICurrentWorkflowState {
  if (action.type === CURRENT_WORKFLOW_PERSISTED) {
    return action.payload;
  } else {
    return state;
  }
}
